import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * ModelViewer component
 */
export default class ScrollingList extends Base {
  breakpoints = ['xxs', 'xs', 's'];

  /**
   * Component Configuration
   */
  static config = {
    name: 'ScrollingList',
    refs: ['list', 'items[]', 'backgrounds[]'],
    options: {
      end: {
        type: Number,
        default: 500,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.currentBackground = this.$refs.backgrounds[0];
    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: `+=${this.$options.end + 50}%`,
        pin: true,
        scrub: true,
      },
    });

    const itemHeight = this.$refs.items[0].offsetHeight + 16;
    const itemWidth = this.$refs.items[0].offsetWidth;

    this.$refs.items.forEach((item, index) => {
      const nextYPosition = index * itemHeight * -1;
      const nextXPosition = index * itemWidth * -1;

      this.tl
        .to(this.$refs.items, {
          y: this.isMobile ? 0 : nextYPosition,
          x: this.isMobile ? nextXPosition : 0,
          stagger: 0.04,
          duration: 0.4,
          ease: 'back.in',
          onReverseComplete: () => {
            this.switchItemStates(index - 1);
          },
          onComplete: () => {
            this.switchItemStates(index);
          },
        })
        .addLabel(`item-${index}`);
    });

    this.tl.to(this.$refs.backgrounds, {
      x: 0,
      duration: 1,
    });
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }

  /**
   * Switch item and image states
   * @param {number} index current index
   * @returns {void}
   */
  switchItemStates(index) {
    if (index < 0) {
      return;
    }

    this.$refs.items.forEach((item, i) => {
      if (i !== index) {
        item.classList.remove('text-green');
        item.classList.add('text-white/30');
      }
    });

    if (this.currentBackground === this.$refs.backgrounds[index]) {
      return;
    }

    if (this.$refs.items[index]) {
      this.$refs.items[index].classList.add('text-green');
      this.$refs.items[index].classList.remove('text-white/30');

      if (this.currentBackground) {
        gsap.to(this.currentBackground, {
          opacity: 0,
          duration: 1,
          ease: 'power4.Out',
        });
      }

      this.currentBackground = this.$refs.backgrounds[index];
      gsap.fromTo(
        this.currentBackground,
        {
          scale: 1.05,
          y: -10,
        },
        {
          scale: 1,
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power4.Out',
        },
      );
    }
  }
}
